
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.482 4.23c-.787-.768-.327-2.108.763-2.225l.135-.002c.35.002.683.146.926.398l5.697 5.725 5.694-5.728c.232-.241.552-.382.887-.393 1.17-.024 1.768 1.399.934 2.224l-5.696 5.728 5.696 5.727c1.413 1.218-.612 3.251-1.821 1.831L10 11.788l-5.696 5.727c-1.212 1.42-3.234-.615-1.822-1.83L8.18 9.956 2.482 4.229z"}})])
          )
        }
      }
    